export enum SocialMetadataType {
  SUMMARY = 'summary',
  SUMMARY_LARGE_IMAGE = 'summary_large_image',
  OBJECT = 'object',
}
